import { SymbolName, TokenSymbol } from 'types'
import { PerpSymbol, SpotSymbol } from '../api/v1/market'
import { Equal } from './equal'

export type CombinedSymbol = SpotSymbol | PerpSymbol

export function findSymbolById(symbols: any[], id: number) {
  if (!symbols || !symbols.length) {
    return undefined
  }
  return symbols.find((item) => item.id === id)
}

export function findSymbolByName(symbols: any[], name: SymbolName) {
  if (!symbols || !symbols.length) {
    return undefined
  }
  return symbols.find((item) => Equal.upperCase(item.name, name))
}

export function findSymbolByCurrency(
  symbols: CombinedSymbol[],
  base: TokenSymbol,
  quote: TokenSymbol
) {
  if (!symbols || !symbols.length) {
    return undefined
  }
  return symbols.find(
    ({ baseCurrency = '', quoteCurrency = '' }) =>
      Equal.upperCase(baseCurrency, base) &&
      Equal.upperCase(quoteCurrency, quote)
  )
}

export function isSpotSymbol(
  symbol: CombinedSymbol | Partial<CombinedSymbol>
): symbol is SpotSymbol {
  return symbol.trade === 'SPOTS'
}
